// assets
import {
  AntDesignOutlined,
  AppstoreAddOutlined,
  BarcodeOutlined,
  BarChartOutlined,
  BgColorsOutlined,
  ChromeOutlined,
  DashboardOutlined,
  LoadingOutlined,
  ProfileOutlined,
  QuestionOutlined
} from '@ant-design/icons';

// icons
const icons = {
  AntDesignOutlined,
  AppstoreAddOutlined,
  BarcodeOutlined,
  BarChartOutlined,
  BgColorsOutlined,
  ChromeOutlined,
  DashboardOutlined,
  LoadingOutlined,
  ProfileOutlined,
  QuestionOutlined
};

// ==============================|| MENU ITEMS - AEGIS WEBSHIELD AI ||============================== //

const aegis = [
  {
    id: 'group-overview',
    type: 'group',
    children: [
      {
        id: 'security-dashboard',
        title: '보안 현황',
        type: 'item',
        url: '/dashboard/security',
        icon: icons.DashboardOutlined,
        breadcrumbs: false
      }
    ]
  },
  {
    id: 'group-projects',
    title: '프로젝트',
    type: 'group',
    children: [
      {
        id: 'project-list',
        title: '프로젝트 목록',
        type: 'item',
        url: '/projects',
        icon: icons.AppstoreAddOutlined
      },
      {
        id: 'target-url-api',
        title: '대상 URL/API',
        type: 'item',
        url: '/projects/targets',
        icon: icons.ChromeOutlined
      },
      {
        id: 'project-members',
        title: '팀/권한',
        type: 'item',
        url: '/projects/members',
        icon: icons.ProfileOutlined
      }
    ]
  },
  {
    id: 'group-scans',
    title: '스캔 관리',
    type: 'group',
    children: [
      {
        id: 'new-scan',
        title: '새 스캔 실행',
        type: 'item',
        url: '/scans/new',
        icon: icons.LoadingOutlined
      },
      {
        id: 'running-scans',
        title: '진행 중 스캔',
        type: 'item',
        url: '/scans/running',
        icon: icons.BarChartOutlined
      },
      {
        id: 'scan-history',
        title: '스캔 이력',
        type: 'item',
        url: '/scans/history',
        icon: icons.BarcodeOutlined
      },
      {
        id: 'recheck',
        title: '재검증',
        type: 'item',
        url: '/scans/recheck',
        icon: icons.QuestionOutlined
      }
    ]
  },
  {
    id: 'group-findings',
    title: '취약점 관리',
    type: 'group',
    children: [
      {
        id: 'finding-list',
        title: '취약점 목록',
        type: 'item',
        url: '/findings',
        icon: icons.BarcodeOutlined
      },
      {
        id: 'finding-exceptions',
        title: '오탐/예외 승인',
        type: 'item',
        url: '/findings/exceptions',
        icon: icons.QuestionOutlined
      },
      {
        id: 'finding-priorities',
        title: '위험도 우선순위',
        type: 'item',
        url: '/findings/priorities',
        icon: icons.BarChartOutlined
      }
    ]
  },
  {
    id: 'group-ai',
    title: 'AI 분석',
    type: 'group',
    children: [
      {
        id: 'ai-analysis-result',
        title: 'AI 분석 결과',
        type: 'item',
        url: '/ai/analysis',
        icon: icons.AntDesignOutlined
      },
      {
        id: 'fix-guide',
        title: 'Fix Guide',
        type: 'item',
        url: '/ai/fix-guide',
        icon: icons.BgColorsOutlined
      },
      {
        id: 'knowledge-search',
        title: '공개 보안 지식 검색',
        type: 'item',
        url: '/ai/knowledge-search',
        icon: icons.ChromeOutlined
      }
    ]
  },
  {
    id: 'group-reports',
    title: '리포트',
    type: 'group',
    children: [
      {
        id: 'report-list',
        title: '리포트 목록',
        type: 'item',
        url: '/reports',
        icon: icons.ProfileOutlined
      },
      {
        id: 'customer-report',
        title: '고객 제출용 리포트',
        type: 'item',
        url: '/reports/customer',
        icon: icons.BarChartOutlined
      },
      {
        id: 'recheck-report',
        title: '재검증 리포트',
        type: 'item',
        url: '/reports/recheck',
        icon: icons.QuestionOutlined
      }
    ]
  },
  {
    id: 'group-cicd',
    title: 'CI/CD Gate',
    type: 'group',
    children: [
      {
        id: 'github-actions',
        title: 'GitHub Actions 연동',
        type: 'item',
        url: '/cicd/github-actions',
        icon: icons.ChromeOutlined
      },
      {
        id: 'gate-policies',
        title: '배포 차단 정책',
        type: 'item',
        url: '/cicd/policies',
        icon: icons.BarcodeOutlined
      },
      {
        id: 'api-tokens',
        title: 'API Token',
        type: 'item',
        url: '/cicd/tokens',
        icon: icons.QuestionOutlined
      }
    ]
  },
  {
    id: 'group-settings',
    title: '설정',
    type: 'group',
    children: [
      {
        id: 'organization-settings',
        title: '조직 설정',
        type: 'item',
        url: '/settings/organization',
        icon: icons.AppstoreAddOutlined
      },
      {
        id: 'user-management',
        title: '사용자 관리',
        type: 'item',
        url: '/settings/users',
        icon: icons.ProfileOutlined
      },
      {
        id: 'audit-logs',
        title: '감사 로그',
        type: 'item',
        url: '/settings/audit-logs',
        icon: icons.BarcodeOutlined
      }
    ]
  }
];

export default aegis;
